const AVATAR_COLORS = [
  '#6366f1', '#8b5cf6', '#ec4899', '#f43f5e',
  '#f97316', '#eab308', '#22c55e', '#14b8a6',
  '#06b6d4', '#3b82f6', '#6d28d9', '#db2777',
];

export function getInitials(firstname, lastname) {
  const first = (firstname || '').charAt(0).toUpperCase();
  const last = (lastname || '').charAt(0).toUpperCase();
  return first + last || '?';
}

export function getAvatarColor(userId) {
  if (!userId) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = userId.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function getDisplayName(conversation, loginUserId, allUsers) {
  if (!conversation) return '';
  if (conversation.category === 'self') return 'Notes to Self';
  if (conversation.type === 'group') return conversation.name || 'Group Chat';
  const other = conversation.participants?.find((p) => p.userId !== loginUserId);
  if (!other) return 'Chat';
  // Try allUsers lookup first
  const otherUser = allUsers?.find((u) => u.id === other.userId);
  if (otherUser?.firstname) {
    return `${otherUser.firstname} ${otherUser.lastname || ''}`.trim();
  }
  // Fallback: use stored userName on participant, or lastMessage senderName
  if (other.userName) return other.userName;
  if (conversation.lastMessage?.senderName && conversation.lastMessage?.senderId === other.userId) {
    return conversation.lastMessage.senderName;
  }
  return other.userId;
}

export function getOtherParticipant(conversation, loginUserId) {
  if (!conversation || conversation.type !== 'direct') return null;
  return conversation.participants?.find((p) => p.userId !== loginUserId);
}

export function getFileIcon(mimeType) {
  if (!mimeType) return 'fi-file';
  if (mimeType.includes('pdf')) return 'fi-file-text';
  if (mimeType.includes('image')) return 'fi-image';
  if (mimeType.includes('video')) return 'fi-video';
  if (mimeType.includes('audio')) return 'fi-music';
  if (mimeType.includes('zip') || mimeType.includes('rar') || mimeType.includes('tar')) return 'fi-archive';
  if (mimeType.includes('sheet') || mimeType.includes('excel') || mimeType.includes('csv')) return 'fi-grid';
  if (mimeType.includes('word') || mimeType.includes('document')) return 'fi-file-text';
  return 'fi-file';
}
